import React, {useState} from 'react'

// query
import { useMutation } from '@apollo/client'
import { BULK_CREATE_CYCLE_COUNT_LOGS } from '../../../../../graphql/cycleCount/cycleCount.mutations'
import { GET_EQUIPMENT_FOR_CYCLE_COUNTS } from '../../../../../graphql/equipment/equipment.queries'
import { apolloClient } from '../../../../../index'

// components
import SideViewModal from '../../../../../components/modals/SideViewModal/SideViewModal.component'

// collections
import CycleCountForm from './CycleCounts.form'

// utils
import { createSubmitData, createCountsFromEquipment } from './CycleCountLog.form.controller.utils'
import { validate } from '../../../../../shared/utility'

const validationSchema = {
    'dateCounted': {
        type: 'date',
        validation: {
            required: true,
            isDate: true
        }
    },
    equipment: {
        type: 'list',
        fields: {
            equipment: {
                type: 'input',
                validation: {
                    required: true
                }
                
            },
            countedQuantity: {
                type: 'input',
                validation: {
                    required: true
                }
            }
            
        }
    }
}

export default function CycleCountLogFormController({ visible, closeForm }) {
    const [editCycleLogs, ] = useMutation(BULK_CREATE_CYCLE_COUNT_LOGS)
    const [counts, setCounts] = useState(null)
    const [isFetchingObject, setIsFetchingObject] = useState(true)
    const [errors, setErrors] = useState({ equipment: []})

    // handle the form submission
    const handleSubmit = (formData) => {

        const submitData = createSubmitData(formData)

        const { isValid, errors } = validate(formData, validationSchema)

        if(isValid) {
            editCycleLogs({ variables: {...submitData}, refetchQueries:[]}).catch(e => {
                console.error(e)
            }).then(result => {
                if(result) {
                    setErrors({ equipment: []})
                    closeForm()
                    setIsFetchingObject(true)
                }
            })
        } else {
            setErrors(errors)
        }
        
    }

    if(visible && isFetchingObject) {
        // fetch the data
        apolloClient.query({ query: GET_EQUIPMENT_FOR_CYCLE_COUNTS, fetchPolicy: 'network-only' }).catch(e => {
            console.error(e)
        }).then(result => {
            if(result) {
                setCounts(createCountsFromEquipment(result.data.equipmentForCycleCounts))
                setIsFetchingObject(false)
            }
        })

        return (null)
    }

    else if(visible && !isFetchingObject && counts) {
        const variants = [
            {
                name: 'Cycle Counts',
                component: <CycleCountForm />,
                stages: 1
            }
        ]
        return (<SideViewModal 
            show={visible} 
            submitText='Save Counts'
            onSubmit={handleSubmit}
            onClose={() => {
                setErrors({ equipment: [] })
                closeForm()
            }}  
            title='Cycle Counts'
            variants={variants}    
            prefillData={counts}
            errors={errors}
        />)
    }

    return null
}